// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dVrl","left":"styles_left__3oVT1","desktopActions":"styles_desktopActions__jrVtz","title":"styles_title__24ylm"};